import React from 'react';

function AddFundsTutorial() {
  return (
    <div className="tutorial-section" style={{
      background: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      padding: '20px',
      margin: '20px 0'
    }}>
      <h3 style={{ color: '#495057', marginBottom: '15px' }}>💰 添加刷分资金与少量bnb</h3>
      
      <div className="tutorial-steps">
        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤1: 添加BNB作为gas费</h4>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            首先去闪兑(交易-&gt;顶栏-&gt;闪兑)里弄1u的bnb 大概够你刷一百次的了。
          </p>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/binance-flash-swap.png"
              alt="币安闪兑"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 币安闪兑界面图片
            </div>
          </div>
        </div>

        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤2: 提取资金到web3钱包</h4>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            拉满了提就完事了, 要刷分的bnb和usdt都提到web3钱包里来。
          </p>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            {[0,1, 2, 3, 4].map((num, index) => {
              const imgSrc =`/images/binance-withdraw${num}.png`;
              
              return (
                <div key={index} style={{ marginBottom: '15px' }}>
                  <img 
                    src={imgSrc}
                    alt={`币安提现到web3钱包 ${num}`}
                    style={{ 
                      maxWidth: '100%', 
                      height: 'auto',
                      border: '1px solid #ddd',
                      borderRadius: '5px'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'block';
                    }}
                  />
                  <div style={{ 
                    display: 'none', 
                    padding: '40px', 
                    backgroundColor: '#f8f9fa', 
                    border: '2px dashed #dee2e6',
                    borderRadius: '5px',
                    color: '#6c757d',
                    textAlign: 'center'
                  }}>
                    📱 币安提现界面图片 {num}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        
        <div className="tutorial-note" style={{
          backgroundColor: '#e2f3ff',
          padding: '15px',
          borderRadius: '5px',
          marginTop: '20px'
        }}>
          <h4 style={{ color: '#0069d9', marginBottom: '10px' }}>注意事项:</h4>
          <p style={{ color: '#495057', fontSize: '14px' }}>
            确保您在BSC网络上有足够的BNB以支付gas费，否则您将无法执行任何交易。
          </p>
        </div>
      </div>
    </div>
  );
}

export default AddFundsTutorial; 